export default __webpack_public_path__ + "static/media/Alvian.c76defb0.png";